import { MenuOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const HeaderSection = styled("header")`
	padding: 1rem 0.5rem;
	position: relative;
	width: 100%;
	box-sizing: border-box;
	overflow-x: hidden;

	.ant-row-space-between {
		align-items: center;
		text-align: center;
	}
`;

export const NavLink = styled("div")`
	display: inline-block;
	text-align: center;
`;

export const CustomNavLink = styled("div")`
	width: 203px;
	display: inline-block;

	@media only screen and (max-width: 411px) {
		width: 150px;
	}

	@media only screen and (max-width: 320px) {
		width: 118px;
	}
`;

export const Burger = styled("div")`
	@media only screen and (max-width: 890px) {
		display: block;
	}

	display: none;

	svg {
		fill: var(--color-primary);
	}
`;

export const NotHidden = styled("div")`
	@media only screen and (max-width: 890px) {
		display: none;
	}
`;

export const Menu = styled("h5")`
	font-size: 1.5rem;
	font-weight: 600;
	text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
	font-size: 1.2rem;
	color: var(--color-text);
	transition: color 0.2s ease-in;
	margin: 0.5rem 2rem;

	@media only screen and (max-width: 768px) {
		margin: 1.25rem 2rem;
	}
`;

export const Label = styled("span")`
	font-weight: 500;
	color: #404041;
	text-align: right;
	display: flex;
	justify-content: space-between;
	align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
	font-size: 22px;
`;

export const Span = styled("span")`
	cursor: pointer;
	transition: all 0.3s ease-in-out;

	&:hover,
	&:active,
	&:focus {
		color: var(--color-primary-hover);
		text-underline-position: under;
		text-decoration: var(--color-primary-hover) wavy underline;
	}
`;

export const Pillars = styled("div")`
	display: flex;
	gap: 1.5rem;
	align-items: center;
`;

export const Pillar = styled("div")`
	font-size: 1.25rem;
	font-weight: 700;
	color: var(--color-heading);
`;

export const RegNumber = styled("div")`
	font-size: 0.95rem;
	color: var(--color-text-secondary, #666);
`;

export const HeaderRow = styled("div")`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-bottom: 0.25rem;
	padding-right: 120px;
	width: 100%;
	box-sizing: border-box;

	@media screen and (max-width: 414px) {
		justify-content: center;
		padding-right: 0;
	}
`;
